import { createFileRoute, notFound } from "@tanstack/react-router";
import { getUILanguage, useAlbertineTranslation } from "albertine-shared-web";
import { PolicyDocument } from "../-components/PolicyDocument";
import { policiesConfigs } from "../-config/policies";

export const Route = createFileRoute("/terms-and-conditions/")({
    component: TermsAndConditionsRoute,
    beforeLoad: () => {
        document.documentElement.style.setProperty(
            "--color-body-top",
            "var(--color-background-profile-secondary)",
        );
        document.documentElement.style.setProperty(
            "--color-body-bottom",
            "var(--color-background-profile-secondary)",
        );
    },
    head: ({ match }) => ({
        meta: [
            {
                title: `Terms and conditions - ${match.search.tenant} ${match.search.locale}`,
            },
        ],
    }),
    onError: () => {
        throw notFound();
    },
});

function TermsAndConditionsRoute() {
    const { tenant } = Route.useSearch();
    const t = useAlbertineTranslation();
    const html = policiesConfigs[tenant].termsAndConditions[getUILanguage().lang];

    return <PolicyDocument title={t("profile__terms-and-conditions")} html={html} />;
}
